import { useMediaQuery } from '@mui/material';
import { IUserProfileData } from '../../createAndEdit/types';
import { formatRecipientLabel } from '../../utils';

interface IDetailInfoBarProps {
  userProfile?: IUserProfileData;
  origin?: string;
  originUserName?: string;
  recipient?: string;
}

const DetailInfoBar = (props: IDetailInfoBarProps) => {
  const isMobile = useMediaQuery('(max-width: 768px)');
  const org = props.userProfile?.account || 'Concessionária';
  const senderName = props.originUserName;
  const originLabel = props.origin ? formatRecipientLabel(props.origin) : '';
  const recipientLabel = props.recipient ? formatRecipientLabel(props.recipient) : '';

  return (
    <div className={`${isMobile ? 'px-2' : 'px-6'} mb-4`}>
      <div className={`flex flex-col items-start gap-3 ${isMobile ? 'text-size-12' : 'text-size-14'}`}>
        <span className="text-gray-600">Enviado por</span>
        <div className={`flex ${isMobile ? 'flex-col gap-1' : 'flex-row items-center gap-3'} ${isMobile ? 'text-size-12' : 'text-size-14'}`}>          
          {originLabel && (
            <>
              <span className="font-bold">{senderName ?? 'Não identificado'} ({originLabel})</span>
            </>
          )}
          {originLabel && recipientLabel && (
            <>
              <span className="text-gray-400 text-size-16">→</span>
            </>
          )}
          {recipientLabel && (
            <>
              <span className="font-bold">{recipientLabel}</span>
            </>
          )}
        </div>
      </div>
      <div className="border-b border-gray-200 mt-3" />
    </div>
  );
};

export default DetailInfoBar;
